import { render } from "./mat-button.vue?vue&type=template&id=ee30ab50&scoped=true&lang=true"
import script from "./mat-button.vue?vue&type=script&lang=js"
export * from "./mat-button.vue?vue&type=script&lang=js"

import "./mat-button.vue?vue&type=style&index=0&id=ee30ab50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee30ab50"]])

export default __exports__